/**
 * ISO 3166-1 alpha-2 country codes with English and German display names.
 * Used for the imprint country dropdown and Stripe prefill.
 */
export const countries: { code: string; en: string; de: string }[] = [
    { code: 'AF', en: 'Afghanistan', de: 'Afghanistan' },
    { code: 'AL', en: 'Albania', de: 'Albanien' },
    { code: 'DZ', en: 'Algeria', de: 'Algerien' },
    { code: 'AD', en: 'Andorra', de: 'Andorra' },
    { code: 'AO', en: 'Angola', de: 'Angola' },
    { code: 'AG', en: 'Antigua and Barbuda', de: 'Antigua und Barbuda' },
    { code: 'AR', en: 'Argentina', de: 'Argentinien' },
    { code: 'AM', en: 'Armenia', de: 'Armenien' },
    { code: 'AU', en: 'Australia', de: 'Australien' },
    { code: 'AT', en: 'Austria', de: 'Österreich' },
    { code: 'AZ', en: 'Azerbaijan', de: 'Aserbaidschan' },
    { code: 'BS', en: 'Bahamas', de: 'Bahamas' },
    { code: 'BH', en: 'Bahrain', de: 'Bahrain' },
    { code: 'BD', en: 'Bangladesh', de: 'Bangladesch' },
    { code: 'BB', en: 'Barbados', de: 'Barbados' },
    { code: 'BY', en: 'Belarus', de: 'Belarus' },
    { code: 'BE', en: 'Belgium', de: 'Belgien' },
    { code: 'BZ', en: 'Belize', de: 'Belize' },
    { code: 'BJ', en: 'Benin', de: 'Benin' },
    { code: 'BT', en: 'Bhutan', de: 'Bhutan' },
    { code: 'BO', en: 'Bolivia', de: 'Bolivien' },
    { code: 'BA', en: 'Bosnia and Herzegovina', de: 'Bosnien und Herzegowina' },
    { code: 'BW', en: 'Botswana', de: 'Botswana' },
    { code: 'BR', en: 'Brazil', de: 'Brasilien' },
    { code: 'BN', en: 'Brunei', de: 'Brunei' },
    { code: 'BG', en: 'Bulgaria', de: 'Bulgarien' },
    { code: 'BF', en: 'Burkina Faso', de: 'Burkina Faso' },
    { code: 'BI', en: 'Burundi', de: 'Burundi' },
    { code: 'CV', en: 'Cabo Verde', de: 'Kap Verde' },
    { code: 'KH', en: 'Cambodia', de: 'Kambodscha' },
    { code: 'CM', en: 'Cameroon', de: 'Kamerun' },
    { code: 'CA', en: 'Canada', de: 'Kanada' },
    { code: 'CF', en: 'Central African Republic', de: 'Zentralafrikanische Republik' },
    { code: 'TD', en: 'Chad', de: 'Tschad' },
    { code: 'CL', en: 'Chile', de: 'Chile' },
    { code: 'CN', en: 'China', de: 'China' },
    { code: 'CO', en: 'Colombia', de: 'Kolumbien' },
    { code: 'KM', en: 'Comoros', de: 'Komoren' },
    { code: 'CG', en: 'Congo', de: 'Kongo' },
    { code: 'CD', en: 'Congo (DRC)', de: 'Kongo (Dem. Rep.)' },
    { code: 'CR', en: 'Costa Rica', de: 'Costa Rica' },
    { code: 'HR', en: 'Croatia', de: 'Kroatien' },
    { code: 'CU', en: 'Cuba', de: 'Kuba' },
    { code: 'CY', en: 'Cyprus', de: 'Zypern' },
    { code: 'CZ', en: 'Czechia', de: 'Tschechien' },
    { code: 'DK', en: 'Denmark', de: 'Dänemark' },
    { code: 'DJ', en: 'Djibouti', de: 'Dschibuti' },
    { code: 'DM', en: 'Dominica', de: 'Dominica' },
    { code: 'DO', en: 'Dominican Republic', de: 'Dominikanische Republik' },
    { code: 'EC', en: 'Ecuador', de: 'Ecuador' },
    { code: 'EG', en: 'Egypt', de: 'Ägypten' },
    { code: 'SV', en: 'El Salvador', de: 'El Salvador' },
    { code: 'GQ', en: 'Equatorial Guinea', de: 'Äquatorialguinea' },
    { code: 'ER', en: 'Eritrea', de: 'Eritrea' },
    { code: 'EE', en: 'Estonia', de: 'Estland' },
    { code: 'SZ', en: 'Eswatini', de: 'Eswatini' },
    { code: 'ET', en: 'Ethiopia', de: 'Äthiopien' },
    { code: 'FJ', en: 'Fiji', de: 'Fidschi' },
    { code: 'FI', en: 'Finland', de: 'Finnland' },
    { code: 'FR', en: 'France', de: 'Frankreich' },
    { code: 'GA', en: 'Gabon', de: 'Gabun' },
    { code: 'GM', en: 'Gambia', de: 'Gambia' },
    { code: 'GE', en: 'Georgia', de: 'Georgien' },
    { code: 'DE', en: 'Germany', de: 'Deutschland' },
    { code: 'GH', en: 'Ghana', de: 'Ghana' },
    { code: 'GR', en: 'Greece', de: 'Griechenland' },
    { code: 'GD', en: 'Grenada', de: 'Grenada' },
    { code: 'GT', en: 'Guatemala', de: 'Guatemala' },
    { code: 'GN', en: 'Guinea', de: 'Guinea' },
    { code: 'GW', en: 'Guinea-Bissau', de: 'Guinea-Bissau' },
    { code: 'GY', en: 'Guyana', de: 'Guyana' },
    { code: 'HT', en: 'Haiti', de: 'Haiti' },
    { code: 'HN', en: 'Honduras', de: 'Honduras' },
    { code: 'HU', en: 'Hungary', de: 'Ungarn' },
    { code: 'IS', en: 'Iceland', de: 'Island' },
    { code: 'IN', en: 'India', de: 'Indien' },
    { code: 'ID', en: 'Indonesia', de: 'Indonesien' },
    { code: 'IR', en: 'Iran', de: 'Iran' },
    { code: 'IQ', en: 'Iraq', de: 'Irak' },
    { code: 'IE', en: 'Ireland', de: 'Irland' },
    { code: 'IL', en: 'Israel', de: 'Israel' },
    { code: 'IT', en: 'Italy', de: 'Italien' },
    { code: 'JM', en: 'Jamaica', de: 'Jamaika' },
    { code: 'JP', en: 'Japan', de: 'Japan' },
    { code: 'JO', en: 'Jordan', de: 'Jordanien' },
    { code: 'KZ', en: 'Kazakhstan', de: 'Kasachstan' },
    { code: 'KE', en: 'Kenya', de: 'Kenia' },
    { code: 'KI', en: 'Kiribati', de: 'Kiribati' },
    { code: 'KP', en: 'North Korea', de: 'Nordkorea' },
    { code: 'KR', en: 'South Korea', de: 'Südkorea' },
    { code: 'KW', en: 'Kuwait', de: 'Kuwait' },
    { code: 'KG', en: 'Kyrgyzstan', de: 'Kirgisistan' },
    { code: 'LA', en: 'Laos', de: 'Laos' },
    { code: 'LV', en: 'Latvia', de: 'Lettland' },
    { code: 'LB', en: 'Lebanon', de: 'Libanon' },
    { code: 'LS', en: 'Lesotho', de: 'Lesotho' },
    { code: 'LR', en: 'Liberia', de: 'Liberia' },
    { code: 'LY', en: 'Libya', de: 'Libyen' },
    { code: 'LI', en: 'Liechtenstein', de: 'Liechtenstein' },
    { code: 'LT', en: 'Lithuania', de: 'Litauen' },
    { code: 'LU', en: 'Luxembourg', de: 'Luxemburg' },
    { code: 'MG', en: 'Madagascar', de: 'Madagaskar' },
    { code: 'MW', en: 'Malawi', de: 'Malawi' },
    { code: 'MY', en: 'Malaysia', de: 'Malaysia' },
    { code: 'MV', en: 'Maldives', de: 'Malediven' },
    { code: 'ML', en: 'Mali', de: 'Mali' },
    { code: 'MT', en: 'Malta', de: 'Malta' },
    { code: 'MH', en: 'Marshall Islands', de: 'Marshallinseln' },
    { code: 'MR', en: 'Mauritania', de: 'Mauretanien' },
    { code: 'MU', en: 'Mauritius', de: 'Mauritius' },
    { code: 'MX', en: 'Mexico', de: 'Mexiko' },
    { code: 'FM', en: 'Micronesia', de: 'Mikronesien' },
    { code: 'MD', en: 'Moldova', de: 'Moldau' },
    { code: 'MC', en: 'Monaco', de: 'Monaco' },
    { code: 'MN', en: 'Mongolia', de: 'Mongolei' },
    { code: 'ME', en: 'Montenegro', de: 'Montenegro' },
    { code: 'MA', en: 'Morocco', de: 'Marokko' },
    { code: 'MZ', en: 'Mozambique', de: 'Mosambik' },
    { code: 'MM', en: 'Myanmar', de: 'Myanmar' },
    { code: 'NA', en: 'Namibia', de: 'Namibia' },
    { code: 'NR', en: 'Nauru', de: 'Nauru' },
    { code: 'NP', en: 'Nepal', de: 'Nepal' },
    { code: 'NL', en: 'Netherlands', de: 'Niederlande' },
    { code: 'NZ', en: 'New Zealand', de: 'Neuseeland' },
    { code: 'NI', en: 'Nicaragua', de: 'Nicaragua' },
    { code: 'NE', en: 'Niger', de: 'Niger' },
    { code: 'NG', en: 'Nigeria', de: 'Nigeria' },
    { code: 'MK', en: 'North Macedonia', de: 'Nordmazedonien' },
    { code: 'NO', en: 'Norway', de: 'Norwegen' },
    { code: 'OM', en: 'Oman', de: 'Oman' },
    { code: 'PK', en: 'Pakistan', de: 'Pakistan' },
    { code: 'PW', en: 'Palau', de: 'Palau' },
    { code: 'PA', en: 'Panama', de: 'Panama' },
    { code: 'PG', en: 'Papua New Guinea', de: 'Papua-Neuguinea' },
    { code: 'PY', en: 'Paraguay', de: 'Paraguay' },
    { code: 'PE', en: 'Peru', de: 'Peru' },
    { code: 'PH', en: 'Philippines', de: 'Philippinen' },
    { code: 'PL', en: 'Poland', de: 'Polen' },
    { code: 'PT', en: 'Portugal', de: 'Portugal' },
    { code: 'QA', en: 'Qatar', de: 'Katar' },
    { code: 'RO', en: 'Romania', de: 'Rumänien' },
    { code: 'RU', en: 'Russia', de: 'Russland' },
    { code: 'RW', en: 'Rwanda', de: 'Ruanda' },
    { code: 'KN', en: 'Saint Kitts and Nevis', de: 'St. Kitts und Nevis' },
    { code: 'LC', en: 'Saint Lucia', de: 'St. Lucia' },
    { code: 'VC', en: 'Saint Vincent and the Grenadines', de: 'St. Vincent und die Grenadinen' },
    { code: 'WS', en: 'Samoa', de: 'Samoa' },
    { code: 'SM', en: 'San Marino', de: 'San Marino' },
    { code: 'ST', en: 'Sao Tome and Principe', de: 'São Tomé und Príncipe' },
    { code: 'SA', en: 'Saudi Arabia', de: 'Saudi-Arabien' },
    { code: 'SN', en: 'Senegal', de: 'Senegal' },
    { code: 'RS', en: 'Serbia', de: 'Serbien' },
    { code: 'SC', en: 'Seychelles', de: 'Seychellen' },
    { code: 'SL', en: 'Sierra Leone', de: 'Sierra Leone' },
    { code: 'SG', en: 'Singapore', de: 'Singapur' },
    { code: 'SK', en: 'Slovakia', de: 'Slowakei' },
    { code: 'SI', en: 'Slovenia', de: 'Slowenien' },
    { code: 'SB', en: 'Solomon Islands', de: 'Salomonen' },
    { code: 'SO', en: 'Somalia', de: 'Somalia' },
    { code: 'ZA', en: 'South Africa', de: 'Südafrika' },
    { code: 'SS', en: 'South Sudan', de: 'Südsudan' },
    { code: 'ES', en: 'Spain', de: 'Spanien' },
    { code: 'LK', en: 'Sri Lanka', de: 'Sri Lanka' },
    { code: 'SD', en: 'Sudan', de: 'Sudan' },
    { code: 'SR', en: 'Suriname', de: 'Suriname' },
    { code: 'SE', en: 'Sweden', de: 'Schweden' },
    { code: 'CH', en: 'Switzerland', de: 'Schweiz' },
    { code: 'SY', en: 'Syria', de: 'Syrien' },
    { code: 'TW', en: 'Taiwan', de: 'Taiwan' },
    { code: 'TJ', en: 'Tajikistan', de: 'Tadschikistan' },
    { code: 'TZ', en: 'Tanzania', de: 'Tansania' },
    { code: 'TH', en: 'Thailand', de: 'Thailand' },
    { code: 'TL', en: 'Timor-Leste', de: 'Osttimor' },
    { code: 'TG', en: 'Togo', de: 'Togo' },
    { code: 'TO', en: 'Tonga', de: 'Tonga' },
    { code: 'TT', en: 'Trinidad and Tobago', de: 'Trinidad und Tobago' },
    { code: 'TN', en: 'Tunisia', de: 'Tunesien' },
    { code: 'TR', en: 'Turkey', de: 'Türkei' },
    { code: 'TM', en: 'Turkmenistan', de: 'Turkmenistan' },
    { code: 'TV', en: 'Tuvalu', de: 'Tuvalu' },
    { code: 'UG', en: 'Uganda', de: 'Uganda' },
    { code: 'UA', en: 'Ukraine', de: 'Ukraine' },
    { code: 'AE', en: 'United Arab Emirates', de: 'Vereinigte Arabische Emirate' },
    { code: 'GB', en: 'United Kingdom', de: 'Grossbritannien' },
    { code: 'US', en: 'United States', de: 'Vereinigte Staaten' },
    { code: 'UY', en: 'Uruguay', de: 'Uruguay' },
    { code: 'UZ', en: 'Uzbekistan', de: 'Usbekistan' },
    { code: 'VU', en: 'Vanuatu', de: 'Vanuatu' },
    { code: 'VA', en: 'Vatican City', de: 'Vatikanstadt' },
    { code: 'VE', en: 'Venezuela', de: 'Venezuela' },
    { code: 'VN', en: 'Vietnam', de: 'Vietnam' },
    { code: 'YE', en: 'Yemen', de: 'Jemen' },
    { code: 'ZM', en: 'Zambia', de: 'Sambia' },
    { code: 'ZW', en: 'Zimbabwe', de: 'Simbabwe' },
];

const byCode = new Map(countries.map(c => [ c.code, c ]));

export function getCountryByCode(code: string): { code: string; en: string; de: string } | undefined {
    return byCode.get(code.toUpperCase());
}

export function getCountryName(code: string, locale: string): string | undefined {
    const entry = byCode.get(code.toUpperCase());
    if (!entry) {
        return undefined;
    }
    return locale.startsWith('de') ? entry.de : entry.en;
}
